import Vue from 'vue'

import { MASKS, applyMask, cleanMaskedNumber } from '@/utilities'
import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEIdentifiersCardActions = {
  initPeIdentifiersCard: ({ commit }) => {
    commit('setPeIdentifiersCardLock', true)
  },
  peIdentifiersCardRefresh: async ({ commit }, { id }) => {
    return axiosRequest.
      get(`/parties/${id}/show_selected`, {
        params: {
          selected: [
            'a_number',
            'identifiers_notes',
            'no_a_number',
            'no_ssn',
            'other_id',
            'ssn',
          ],
        },
      }).
      then(({ data }) => {
        commit('setPeIdentifiersCardLock', true)
        commit('pePatchParty', {
          a_number: applyMask(data.a_number, MASKS.ANUMBER),
          identifiers_notes: data.identifiers_notes,
          no_a_number: data.no_a_number,
          no_ssn: data.no_ssn,
          other_id: data.other_id,
          ssn: applyMask(data.ssn, MASKS.SSNUMBER),
        })
      }).
      catch(handleError)
  },
  peIdentifiersCardUpdate: async ({ commit }, { id, section }) => {
    return axiosRequest.
      patch(`/parties/${id}`, {
        a_number: cleanMaskedNumber(section.a_number),
        identifiers_notes: section.identifiers_notes,
        no_a_number: section.no_a_number,
        no_ssn: section.no_ssn,
        other_id: section.other_id,
        ssn: cleanMaskedNumber(section.ssn),
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeIdentifiersCardLock', true)
        commit('pePatchParty', {
          a_number: applyMask(updatedParty.a_number, MASKS.ANUMBER),
          identifiers_notes: updatedParty.identifiers_notes,
          no_a_number: updatedParty.no_a_number,
          no_ssn: updatedParty.no_ssn,
          other_id: updatedParty.other_id,
          ssn: applyMask(updatedParty.ssn, MASKS.SSNUMBER),
        })
      }).
      catch(handleError)
  },
}

export const PEIdentifiersCardMutations = {
  setPeIdentifiersCardLock: (state, lock) => {
    Vue.set(state.partyEdit.partySections, 'IdentifiersCard', lock)
  },
}

export const PEIdentifiersCardGetters = {
  peIdentifiersCardLock: state => state.partyEdit.partySections.IdentifiersCard,
}
